import type { MonolithImageSizeFragment } from '@/graphql/api'
import type { ImageProps } from '@/components/Image.vue'

export function getGenericImageProps({
    size,
    size_x2,
    ...props
}: {
    size: MonolithImageSizeFragment
    size_x2?: MonolithImageSizeFragment
} & Omit<ImageProps, 'src' | 'width' | 'height' | 'sources'>): ImageProps {
    return {
        src: size.url,
        sources: size.sources.map((src, i) => {
            const srcset: `${string} ${number}x`[] = [`${src.url} 1x`]
            const size_x2_src = size_x2?.sources[i]

            if (size_x2_src) {
                srcset.push(`${size_x2_src.url} 2x`)
            }

            return {
                mimeType: src.mimeType,
                srcset,
            }
        }),
        ...props,
    }
}
